import { FormattedMessage } from 'react-intl';

import CardWrapper from 'components/CardWrapper';

export default () => (
  <CardWrapper>
    <FormattedMessage id="no elements found" />
  </CardWrapper>
);
